import { router } from '@inertiajs/react';
import { isTrackablePath, normalizePath } from './menuPath';

/** Navega para href do menu: rotas Nexus via Inertia; demais via full page. */
export function navigateToHref(
    href: string | null | undefined,
    target?: string | null,
): void {
    const raw = href?.trim() || '#';
    if (
        raw === '#' ||
        raw.startsWith('javascript:') ||
        raw.startsWith('mailto:') ||
        raw.startsWith('tel:')
    ) {
        return;
    }

    if (target === '_blank') {
        window.open(raw, '_blank', 'noopener,noreferrer');
        return;
    }

    const path = normalizePath(raw);
    if (isTrackablePath(path)) {
        router.visit(path);
        return;
    }

    window.location.href = raw;
}
